import { META_DATA } from 'src/constants'
import Metadata from 'src/components/Metadata'

const defaultTile = 'FirstWord'
const defaultDescription =
  'FirstWord is a leading provider of news and analysis for the global pharmaceutical industry. We deliver the latest insights and updates to help you stay informed and make better decisions.'

const SetMetaData = pageName => {
  return (
    <Metadata
      title={META_DATA[pageName]?.title ?? defaultTile}
      description={META_DATA[pageName]?.description ?? defaultDescription}
    />
  )
}

export default SetMetaData
